<template>
    <div>
        <navbar :title="text"></navbar>
        <div class="zhanshi">
            <div>
                <img src="@/assets/yuwen.png" alt="">
                <p>{{makeCourse_list.name}}</p>
            </div>
            <div>
                开课时间：{{makeCourse_list.classtime_begin}}
            </div>
            <div>
                <img src="@/assets/xioayalaoshi.png" alt="">
                <p>主讲：{{makeCourse_list.speak_teacher}}</p>
            </div>          
        </div>

        <van-tabs v-model="activeName" title-active-color="#000" title-inactive-color="#828282">
            <van-tab title="课程列表" name="a" v-if="this.$route.query.livetype == 1">
                <div class="zhibolist" 
                    v-for="(courselistb) in course_listbc"
                    v-bind:key="courselistb.cid" 
                    @click="listclick(courselistb)">
                    <div>
                        <img src="@/assets/videoico.png" alt="">
                        <p>{{ courselistb.name }}</p>
                    </div>
                    <div class="clear">
                        <van-col offset="0" span="14">
                            <div v-if="courselistb.live_status =='1'" style="color:#999999">未开始</div>
                            <div v-if="courselistb.live_status =='2'" style="color:red;">直播中</div>
                            <div v-if="courselistb.live_status =='3'" style="color:#999999">已结束</div>
                        </van-col>
                        <van-col v-if="courselistb.live_status =='1' || courselistb.live_status =='2'" offset="" span="10">{{courselistb.classtime_begin}}</van-col>   
                        <van-col v-if="courselistb.live_status =='3'" offset="" span="10">{{courselistb.classtime_end}}</van-col>   
                    </div>
                </div>
            </van-tab>
            <van-tab title="课程介绍" name="b">
                <img :src="makeCourse_list.profile_photo" width="100%" alt="">
            </van-tab>
            <!-- <van-tab title="课程体验" name="c">
                <video  autoplay  :src= this.makeCourse_list.experience_url  controls  name="media"  class="videoSize"> </video>
            </van-tab> -->
            <div class="btn clear">
                <div class="fl">
                    <div class="money">
                        <span>￥{{makeCourse_list.price}}</span>
                        <span>￥{{makeCourse_list.sale_price}}</span>
                    </div> 
                    <div class="baoming">{{makeCourse_list.buy_num}}人报名</div>
                </div>
                <div class="fr">
                    <!-- 1：系列  2：单独课程--> 
                    <div class="btns" v-if="course_type == 2">
                    <!-- 判断是付费课程还是直播课程 1付费 2密码-->
                    <div v-show="this.live_type == 1">
                        <!-- 判断是否付款 0：未付款 1：付款 -->
                        <van-button type="primary"  
                            @click="handleOrderClass(course_id)"
                            v-show="makeCourse_list.buy_status == 0"
                        >立即报名</van-button>

                        <van-button type="primary" 
                            v-show="makeCourse_list.buy_status == 1"
                            @click="handleStartClass()"
                        > 立即学习
                        </van-button>    
                    </div>
                    <van-button type="primary" 
                        @click="pawpupshow()"
                        v-show="this.live_type == 2"
                        class="order_class_btn_blue horizontal_center margT_10"
                    >立即学习</van-button> 
                    </div>

                    <!-- 系列课程按钮 -->
                    <div v-if="course_type == 1"> 
                        <van-button type="primary"  
                        @click="handleOrderClass(course_id)"
                            v-show="makeCourse_list.buy_status == 0"
                        >立即报名</van-button>
                        <van-button type="primary" disabled v-show="makeCourse_list.buy_status == 1">已报名</van-button>
                    </div>
                </div>
            </div>
        </van-tabs>

    </div>
</template>

<script>
import URL from '../../api/index'
import navbar from '../../components/Navbar'
import Vue from 'vue';
import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
// import '@/assets/classmatter.css'
import http from '@/plugins/http.js'
//折叠面板
import { Collapse, CollapseItem } from 'vant';
Vue.use(Collapse);
Vue.use(CollapseItem);
//栅格
import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);
Vue.use(http)
//按钮
import { Button } from 'vant';
Vue.use(Button);
import { Toast } from 'vant';
Vue.use(Toast);
import { Loading } from 'vant';
Vue.use(Loading);
export default {
    components:{
        navbar
    },
    data(){
        return{
            datas:[],
            text:'直播详情',
            activeName: 'a',
            course_listbc:[],
            makeCourse_list:{
                subject_name:'',
                name:'',
                experience_url:'',
                profile_photo:'',
                classtime_begin:'',
                classtime_end:'',
                course_type:'',
            },
            planste: false,
            userinfo:'',
            course_id:'',
            photoval:'',
            course_type:'',
            live_type:'',
            userInfo:'',
            btnavtive: false,
            livepwd:'',
            load:false,
            liveDetail: {},
            liveLocation:'',
            course_listb:[],
            userInfo: {},
            Cida:'',
            coursetype:'',
            cidb:'',
            isshow:true
        }
    },
    mounted(){
            if (localStorage.getItem("userInfo")) {
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
                //  console.log('youdongxi');
            }
            console.log();
            this.getuserinfo();
            this.getMakeCourseList();//获取详情
            this.courselist()//系列课程列表 
            this.getParams();
        },
        methods:{
            icon () {
                this.$router.go(-1)
            },
            pawpupshow(){
                this.btnavtive = true
            },
            offpopbtn(){//关闭图片
                this.btnavtive = false//密码弹窗
            },

            listclick(courselistb){
                // console.log(courselistb)
                  //报名状态 0 为立即报名 1 为报名完学习  
                this.buystatus = this.makeCourse_list.buy_status;
                this.lxcid = courselistb.cid;       
                // console.log(this.lxcid,"系列cid")
                this.Type = courselistb.type;
                // 直播类型  是密码直播还是付费直播 livetype 为1 付费直播 2密码直播
                if( courselistb.livetype == 1 ){
                    // 判断类型是已付款还是未付款 buystatus  0：未付款  1：已付款
                    if( this.buystatus == 0 ){
                    this.handleOrderClass(courselistb);
                    }else{  
                        if( courselistb.live_status == 1 ){//未直播
                        alert("直播还未开始");
                        }
                        if( courselistb.live_status == 2 ){//直播中
                        this.handleStartSeries(courselistb)
                        }
                        if( courselistb.live_status == 3 ){//已结束
                        this.handleStartSeries(courselistb)
                        } 
                    }
                }else if(  courselistb.livetype == 2  ){
                this.pawpupshow();
                }     
            },

            livepwdbtn(){//密码确定
                // /live/course/checkClassPwd 
                var inppwd = this.livepwd;
                // 判断课程  1：系列   2：单独课程
                if( this.course_type == 1 ){
                    this.cida = this.Cid
                    // console.log(this.cida,"系列")
                }else if( this.course_type == 2 ){
                    this.cida = this.course_id
                    // console.log(this.course_id)
                    // console.log(this.cida,"课程")
                }

                if( !inppwd){
                     Toast("密码不能为空");
                    return ;
                }
                this.$http.post('/live/course/checkClassPwd',
                    {
                    token: this.userInfo.token,
                    cid: this.cida,
                    classpwd: inppwd,
                    }
                )
                .then(pwdreturn => {
                    // console.log(pwdreturn)
                    this.livesta = pwdreturn.data.state
                    if( this.livesta == 0 ){
                    this.handleStartClass()
                    }else{
                        Toast(pwdreturn.data.msg);
                    }
                })
                },


            getuserinfo(){//获取需要的信息
                this.course_id = this.$route.query.cid;
                // this.course_id =  '809965'
                // this.course_type = '1'
                this.course_type = this.$route.query.type;
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
                // console.log(this.userInfo);
            },

            async getMakeCourseList () {//获取课程信息
                
                var params = {}
                if (this.course_id) {
                    params.cid= this.course_id;
                }
                var href = window.location.href
                    if (href.indexOf('course_id') > 0) {
                    var course_id = href.substring((href.indexOf('course_id=') + 3),href.length);
                }
                if (!this.course_id) {
                    params.cid=this.course_id;
                }
                if(this.userInfo && this.userInfo.token) {
                    params.token = this.userInfo.token;
                }
                // console.log(params)
                const makeCourseRes=await this.$http.post ('/live/course/index',params)
                // console.log(makeCourseRes)

                if (makeCourseRes.data.state===0) {
                // debugger
                this.makeCourse_list = makeCourseRes.data.result
                    // console.log(this.makeCourse_list)
                }else if (makeCourseRes.data.msg===1){
                    Toast(makeCourseRes.data.msg);
                }
                if( this.makeCourse_list.profile_photo == "" ){
                    this.photoval = false
                }else{
                    this.photoval = true
                }
            },
            
            courselist(){//获取系列课程列表 
                this.load = true;
                // this.course_id = JSON.parse(this.$route.query.course_id);
                // this.course_type = this.$route.query.course_type;
                // this.course_type = '2'// 课程类型  1：系列  2：单独课程
                this.live_type = this.$route.query.livetype;//直播类型
                // console.log(this.live_type,"直播类型")
                if( this.course_type == 1 ){
                    this.planste = true
                    this.$http.post('/live/index/series_courseinfo',
                        {
                            c_id: this.course_id
                        },{
                            emulateJSON:true
                        }
                    )
                    .then(listb => {
                        if(listb.data.state == 0){
                            this.load = false;
                            this.course_listbc = listb.data.result; 
                            console.log(this.course_listbc)
                        }else if(listb.data.state ==  1){
                            Toast(listb.data.result.name);
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                    }) 
                }else{
                    this.planste = false
                }
            },

            // study(){
            //     this.$router.push({
            //         name:'playback',
            //         query:{
            //             xlcid: this.course_id,
            //             kccid: '444894',
            //             coursetype: this.course_type
            //         }
            //     })
            // },
            async handleOrderClass(course_id) {
                console.log('获取下单号码前的')
                // console.log(course)
                console.log(this.course_id,"cid")
                console.log(this.userInfo.token)
                //未登录 是否登录
                if (this.userInfo === null || this.userInfo.token === null ||  this.userInfo.token === undefined) {
                    console.log('未登录');
                    this.$router.push({path:'/login'})
                    return
                }else{
                    console.log("1231")
                }

                let ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    console.log('微信')
                    var that=this
                    this.$axios({
                        method:'post',
                        url:URL.unifiedorder,
                        data:{
                            cid: this.course_id,
                            token:this.userInfo.token
                        }
                    }).then((res)=>{
                        if(res.data.state === 0){
                            console.log('收费');                          
                            var datas = res.data.result.data
                            that.jsApiCall(datas) 
                            return 
                        } else if(res.data.state = 1 && res.data.msg == "免费课程，不需要付款"){{
                                console.log('免费');      
                                this.makeCourse_list.buy_status = 1                                                  
                            }
                        }
                    })
                    } else {
                    console.log('支付宝');
                    const orderCard = await this.$http.post('/live/payment/add_refill',
                    {cid:this.course_id,token:this.userInfo.token},
                    {
                        headers: { 'content-type': 'application/x-www-form-urlencoded' }
                    }
                    )
                        if (orderCard.data.state ===0) {
                        this.orderCardNum = orderCard.data.result
                        console.log('获取下单的号码')
                        console.log(this.orderCardNum)

                        //如果课程价格是0，不需要生成订单，直接立即学习即可
                        if (this.makeCourse_list
                            && this.makeCourse_list.sale_price
                            && this.makeCourse_list.sale_price === "0.00") {
                            this.makeCourse_list.buy_status = 1
                            console.log(1);
                            
                            return
                        }

                        this.toOrder(this.orderCardNum)
                        }else if (orderCard.data.state ===1) {
                            this.$router.push({path:'/login'})
                            console.log(2);
                        }
                }
            },
            jsApiCall(data)
                {
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    data,
                    function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            window.location.reload() 
                        } else if(res.err_msg == "get_brand_wcpay_request:cancel"){
                            alert("已取消支付")
                        } else if(res.err_msg == "get_brand_wcpay_request:fail"){
                            alert("支付失败")
                        }
                    }
                );
            },
            callpay()
                {
                if (typeof WeixinJSBridge == "undefined"){
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
                        document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
                    }
                }else{
                    jsApiCall();
                }
            },
            handleStartClass: function () {
                let userInfo = JSON.parse(localStorage.getItem("userInfo"))
                console.log("立即学习")
                this.token = this.userInfo.token
                this.Cid = this.makeCourse_list.cid
                console.log(this.Cid,"cid");
                //未登录 是否登录
                if (this.userInfo === null || this.userInfo.token === null) {
                    this.$router.push({path:'/login'})
                return
                }
                if (this.makeCourse_list.live_status === '3') {
                //回放
                this.$router.push({
                    name:'playback',
                    query:{
                    //liveDetail:JSON.stringify(this.makeCourse_list)
                    coursetype: this.course_type,
                    cida: this.cida,//系列
                    Cid: this.Cid,
                    //Type:this.Type,
                    Token:this.token
                    }
                })
                
                console.log("进入判断")
                } 
                else if (this.makeCourse_list.live_status === '2') {
                //直播
                this.$router.push({
                    name:'whiteBoard',
                    query:{
                    userInfo: userInfo,
                    liveDetail:{
                        room_id: this.makeCourse_list.cid,
                        speaker_teacher_id: this.makeCourse_list.speaker_teacher_id,
                    }
                    }
                })
                }if (this.makeCourse_list.live_status === '1') {
                    Toast('直播未开始');
                }
            },
            //如若报名成功，立即学习事件
            handleStartSeries:function(courselistb) {//xiliekechengfangfa
                let userInfo = JSON.parse(localStorage.getItem("userInfo"))
                console.log("立即学习")
                this.token = this.userInfo.token
                this.Cid = courselistb.cid
                this.live_status = courselistb.live_status
                console.log(this.Cid);
                console.log(this.live_status);
                if (this.live_status === '3') { 
                //回放
                this.$router.push({
                    name:'playback',
                    query:{
                    //liveDetail:JSON.stringify(this.makeCourse_list)
                    xlcid: this.Cid,//系列
                    Cid: this.Cid,
                    // Cid: this.cida,
                    //Type:this.Type,
                    Token:this.token,
                    coursetype: this.course_type,
                    }
                })
                
                console.log("进入判断")
                } 
                else if (this.live_status === '2') {
                //直播  
                this.$router.push({
                    name:'whiteBoard',
                    query:{
                    userInfo:userInfo,
                    liveDetail:{
                        room_id: courselistb.cid,
                        speaker_teacher_id: courselistb.speaker_teacher_id,
                    }
                    }
                })
                }if (this.live_status === '1') {
                    Toast('直播未开始');
                    console.log("xiliekechengfangfa")
                }
            },
            getParams() {
                var that=this
                // 接收传过来的课程信息
                //this.liveDetail = JSON.parse(this.$route.query.liveDetail);
                this.Cida = this.$route.query.xlcid;//系列
                this.Cid = this.$route.query.Cid;//课程
                // this.Type = this.$route.query.Type
                this.Token = this.$route.query.Token
                // this.Token = 'e10b82bc219d3c328e0e4c89890fe286'
                this.coursetype = this.$route.query.coursetype
                //判断课程  1：系列   2：单独课程
                // console.log(this.Cida)
                if( this.coursetype == 1 ){
                    this.cidb = this.Cida
                    console.log(this.cidb)
                }else if( this.coursetype == 2 ){
                    console.log("2222222222")
                    this.cidb = this.Cid
                    console.log(this.cidb)
                   
                }
                this.$http.post('/live/course/index',
                    {  
                        cid: this.cidb,
                        token: this.Token
                    },{
                        emulateJSON:true
                    }
                )
                .then(list => { 
                    this.course_listb = list.data.result; 
                    that.isshow=false
                    // console.log(this.course_listb)  
                })
                .catch(error => {
                    // console.log("error.response")
                })
            }
        },
}
</script>


<style scoped>
/* *{
    margin: 0;
    padding: 0;
} */
.zhanshi{
    padding: 15px;
}
.zhanshi div:first-child{
    font-size: 16px;
}
.zhanshi div:first-child img{
    width: 10%;
    display: inline-block;
    vertical-align: middle;
}
.zhanshi div:first-child p{
    display: inline-block;
    vertical-align: middle;
}
.zhanshi div:nth-child(2){
    font-size: 12px;
    line-height: 42px;
	color: #949494;
}
.zhanshi div:last-child img{
    width: 10%;
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%;
    
}
.zhanshi div:last-child p{
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
}

.van-tabs /deep/ .van-tabs__line{

    width: 20px !important;
	background-color: #3c69f5;
    transform: translateX(62.5px) translateX(-50%);
}
.van-tabs /deep/ .van-tab__pane{
    margin-top: 15px;
}

.zhibolist{
    line-height: 28px;
    padding: 10px 15px;
    font-size: 14px;
}
.icon{
    float: left;
    width: 16px;
    height: 16px;
    margin: 7px 4px 0 0;
    background: url(/static/img/videoico.64a60d4.png) no-repeat 50%;
    background-size: 100%;
}
.clear /deep/ .van-col{
    color: rgb(153, 153, 153);
}

.btn{
    width: 92%;
    background: #FFF;
    padding:  0 15px;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 233;
    border-top: 2px solid #eff1f5;
}
.money span:first-child{
    font-size: 14px;
    color: #6e7578;
    text-decoration: line-through;
}
.money span:last-child{
    color: rgba(244, 21, 33, 1);
    font-size: 18px;

}
.baoming{
    font-size: 14px;
    line-height: 20px;
}

.van-button /deep/{
    position: relative;
    top: 6px;
    display: inline-block;
    font-size: 14px;
    line-height: 28px;
    height: auto;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
}

.videoSize{
    width: 100%;
}
.zhibolist {
    font-size: 14px;
    padding: 0 15px;
}
.zhibolist img {
    width: 16px;
    vertical-align: middle;
    display: inline-block;
}
.zhibolist div:first-child p {
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    margin: 0;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/zhiboxq/zhiboxq.vue